import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationHttpService } from "../../../core/services/application-http.service";
import { FeedItem, FeedResponse } from "../registration/components/feed/feed.component";
import { PostRegSubjectRef } from "../../../shared/models/post-reg-subject.model";
import { subjectQuery } from "./application-history.service";

/** Feed / comments thread for an application, or for one post-registration event of it. */
@Injectable()
export class ApplicationFeedService {

    constructor(private http: ApplicationHttpService) {
    }

    /**
     * With `backOfficePostRegEventId` api-int returns only the entries linked to that event; adding
     * `subject` narrows them to one person of it (the subject is ignored without an event id).
     */
    getFeedList(applicationId: string, pageNumber: number, pageSize: number, backOfficePostRegEventId?: number | null,
                subject?: PostRegSubjectRef | null): Observable<FeedResponse> {
        const event = backOfficePostRegEventId != null
            ? `&backOfficePostRegEventId=${backOfficePostRegEventId}${subjectQuery(subject)}`
            : '';
        return this.http.get<FeedResponse>(`feed/${applicationId}?pageNumber=${pageNumber}&pageSize=${pageSize}${event}`);
    }

    canSendFeed(): Observable<boolean> {
        return this.http.get<boolean>(`feed/add-comment-check`);
    }

    /** With `backOfficePostRegEventId` the comment is stored against that event (shown in its Feed tab). */
    sendFeed(backOfficeApplicationId: number, comment: string, backOfficePostRegEventId?: number | null): Observable<FeedItem> {
        const body = backOfficePostRegEventId != null
            ? { backOfficeApplicationId, comment, backOfficePostRegEventId }
            : { backOfficeApplicationId, comment };
        return this.http.post<FeedItem>(`feed/add-comment`, body);
    }
}
